import React from "react";
import { useSelector } from "react-redux";
import { Backdrop, CircularProgress } from "@mui/material";
import { styled } from '@mui/material/styles';
import { colorStyling } from "../../helpers/color";

const PREFIX = 'Loading';

const classes = {
  backdrop: `${PREFIX}-backdrop`
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
const StyledBox = styled('span')((
  {
    theme
  }
) => ({
  [`& .${classes.backdrop}`]: {
    zIndex: theme.zIndex.drawer + 1,
  }
}));

const Loading = () => {
  const { loading } = useSelector((state) => state.global);
  return (
    <StyledBox>
      <Backdrop className={classes.backdrop} open={loading}>
        <CircularProgress style={{ color: colorStyling.primary }} />
      </Backdrop>
    </StyledBox>
  );
};

export default Loading;
